import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth, LoginPage } from './auth';  // Updated imports
import RandomOLLExecution from './components/practice/oll/RandomOLLExecution';
import RandomPLLExecution from './components/practice/pll/RandomPLLExecution';
import SingleOLLExecution from './components/practice/oll/SingleOLLExecution';
import SinglePLLExecution from './components/practice/pll/SinglePLLExecution';
import Home from './components/Home/Home';
import Statistics from './components/statistics/views/Statistics';
import OLLRecognitionExecution from './components/practice/oll/OLLRecognitionExecution';
import PLLRecognitionExecution from './components/practice/pll/PLLRecognitionExecution';
import SlowestAlgorithms from './components/statistics/views/SlowestAlgorithms';
import TermsOfUse from './components/legal/TermsOfUse';
import Footer from './components/common/navigation/Footer';
import ReleaseNotes from './components/ReleaseNotes';

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <div className="app-container">
        <Routes>
          <Route path="/terms" element={<TermsOfUse />} />
          
          {!user ? (
            <>
              <Route path="/login" element={<LoginPage />} />  {/* Updated component name */}
              <Route path="*" element={<Navigate to="/login" replace />} />
            </>
          ) : (
            <>
              <Route path="/" element={<Home />} />
              <Route path="/random-oll" element={<RandomOLLExecution />} />
              <Route path="/random-pll" element={<RandomPLLExecution />} />
              <Route path="/single-oll" element={<SingleOLLExecution />} />
              <Route path="/single-pll" element={<SinglePLLExecution />} />
              <Route path="/stats/:mode/:algorithmId" element={<Statistics />} />
              <Route path="/oll-recognition" element={<OLLRecognitionExecution />} />
              <Route path="/pll-recognition" element={<PLLRecognitionExecution />} />
              <Route path="/slowest-algorithms" element={<SlowestAlgorithms />} />
              <Route path="/release-notes" element={<ReleaseNotes />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </>
          )}
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App; 